{
  "title": "Warehouse & Location Master",
  "subtitle": "Warehouse → Zone (optional) → Location. A Location is a Rack or a Bin, never nested.",
  "selectWarehouse": "Warehouse",
  "addWarehouse": "Add Warehouse",
  "editWarehouse": "Edit Warehouse",
  "addZone": "Add Zone",
  "allZones": "All Zones",
  "addLocation": "Add Location",
  "branchLabel": "Branch: {{branch}}",
  "warehouseLimitLabel": "{{count}} of {{limit}} warehouses used",
  "warehouseLimitUnlimitedLabel": "{{count}} warehouses (unlimited)",
  "table": {
    "code": "Code",
    "locationType": "Type",
    "storageType": "Storage",
    "zone": "Zone",
    "capacity": "Capacity",
    "status": "Status"
  },
  "form": {
    "code": "Code",
    "name": "Name",
    "address": "Address",
    "description": "Description",
    "locationType": "Location Type",
    "storageType": "Storage Type",
    "rowNo": "Row",
    "columnNo": "Column",
    "maxWeight": "Max Weight (kg)",
    "maxVolume": "Max Volume (m³)",
    "zone": "Zone (optional)",
    "noZone": "No Zone",
    "validation": {
      "codeRequired": "Code is required.",
      "nameRequired": "Name is required."
    }
  },
  "noWarehouses": "No warehouses yet — add one to get started.",
  "deleteLocation": {
    "message": "Locations that currently hold stock cannot be deleted."
  },
  "deleteZone": {
    "message": "Zones that still have locations assigned cannot be deleted."
  },
  "qrPrint": {
    "title": "Print QR Code Label",
    "hint": "A scan-ready QR code with the code printed underneath, sized for a sticker label to stick directly on the rack, bin, or zone.",
    "printZoneTooltip": "Print QR label for this zone",
    "printLocationTooltip": "Print QR label for this location",
    "close": "Close",
    "printButton": "Print Label"
  }
}
